const translations = {
  // Navbar
  nav_home: 'Accueil',
  nav_contact: 'Nous Contacter',
  nav_get_in_touch: 'Nous Joindre',

  // Hero
  hero_tag: 'Innovation',
  hero_title_line1: 'Des solutions',
  hero_title_line2: 'avant-garde',
  hero_contact_btn: 'Nous Contacter',

  // About Section (home)
  about_tag: 'Qui Nous Sommes',
  about_title: 'Engag\u00e9s envers l\u2019Excellence',
  about_title_highlight: 'Scientifique',
  about_title_suffix: 'et les Soins aux Patients',
  about_p1: 'Vixtra Inc. est une nouvelle soci\u00e9t\u00e9 pharmaceutique ax\u00e9e sur le d\u00e9veloppement, la fabrication et la distribution de produits combinatoires uniques pour des applications o\u00f9 il existe un besoin clinique non satisfait \u00e9vident ou qui peuvent avoir un impact significatif sur la qualit\u00e9 des soins.',
  about_p2: 'Gr\u00e2ce \u00e0 des relations strat\u00e9giques existantes et \u00e0 l\u2019acc\u00e8s \u00e0 plusieurs technologies et plateformes brevet\u00e9es, les produits de Vixtra offriront des performances cliniques in\u00e9gal\u00e9es dans divers domaines th\u00e9rapeutiques en pharmacie humaine.',

  pillar_dev_title: 'D\u00e9veloppement',
  pillar_dev_desc: 'Pionniers de produits pharmaceutiques combinatoires uniques r\u00e9pondant aux besoins cliniques non satisfaits.',
  pillar_mfg_title: 'Fabrication',
  pillar_mfg_desc: 'Processus de fabrication de pointe garantissant les normes de qualit\u00e9 les plus \u00e9lev\u00e9es.',
  pillar_dist_title: 'Distribution',
  pillar_dist_desc: 'R\u00e9seaux de distribution strat\u00e9giques livrant les produits l\u00e0 o\u00f9 ils sont le plus n\u00e9cessaires.',

  // Stats Section
  stat1_value: 'Brevet\u00e9es',
  stat1_label: 'Technologies & Plateformes',
  stat2_value: 'Uniques',
  stat2_label: 'Produits Combinatoires',
  stat3_value: 'Multiples',
  stat3_label: 'Domaines Th\u00e9rapeutiques',
  stat4_value: 'Strat\u00e9giques',
  stat4_label: 'Relations Industrielles',

  // Contact CTA
  cta_tag: 'Nous Joindre',
  cta_title: 'Comment nous contacter',
  cta_desc: 'Parlez \u00e0 un repr\u00e9sentant de Vixtra concernant nos produits et services.',
  cta_btn: 'Nous Contacter',

  // Contact Page
  contact_page_tag: 'Nous Rejoindre',
  contact_page_title: 'Contactez-nous',
  contact_page_subtitle: 'Des questions sur nos produits ou services\u00a0? Nous serions ravis de vous entendre.',
  contact_breadcrumb: 'Contactez-nous',
  contact_info_tag: 'Nous Joindre',
  contact_info_title: 'Nous sommes l\u00e0 pour vous',
  contact_info_desc: 'Si vous avez des questions ou souhaitez parler \u00e0 un repr\u00e9sentant de Vixtra Inc. concernant nos produits et services, veuillez nous contacter par l\u2019un des moyens ci-dessous.',
  contact_email_label: 'Envoyez-nous un courriel',
  contact_phone_label: 'Appelez-nous',
  contact_form_title: 'Envoyez-nous un message',
  contact_first_name: 'Pr\u00e9nom',
  contact_last_name: 'Nom de Famille',
  contact_email: 'Adresse Courriel',
  contact_phone: 'Num\u00e9ro de T\u00e9l\u00e9phone',
  contact_subject: 'Sujet',
  contact_subject_placeholder: 'S\u00e9lectionnez un sujet',
  contact_subject_products: 'Produits & Services',
  contact_subject_partnership: 'Demande de Partenariat',
  contact_subject_general: 'Demande G\u00e9n\u00e9rale',
  contact_subject_other: 'Autre',
  contact_message: 'Message',
  contact_message_placeholder: 'Dites-nous comment nous pouvons vous aider...',
  contact_submit: 'Envoyer le Message',
  contact_submitting: 'Envoi en cours...',
  contact_success_title: 'Message Envoy\u00e9\u00a0!',
  contact_success_desc: 'Merci de nous avoir contact\u00e9s. Un repr\u00e9sentant de Vixtra vous r\u00e9pondra sous peu.',

  // Footer
  footer_nav_title: 'Navigation',
  footer_contact_title: 'Contact',
  footer_copyright: '\u00a9 Vixtra 2026. Tous droits r\u00e9serv\u00e9s.',

  // Cookie Consent
  cookie_message: 'Nous utilisons des cookies pour am\u00e9liorer votre exp\u00e9rience sur notre site. En continuant \u00e0 naviguer, vous acceptez notre utilisation des cookies.',
  cookie_accept: 'Accepter',
  cookie_decline: 'Refuser',
  cookie_policy_link: 'Politique de Cookies',
};

export default translations;
